export const errorStrings = {
  noRecordsFound: 'No records found.',
  noDilisaCard: 'No Dilisa is linked.',
};
